import { Link } from 'react-router-dom';

export default function Footer() {
  const footerLinks = [
    {
      title: '内容分类',
      links: [
        { label: '性健康知识', to: '/category/xing-jian-kang-zhi-shi' },
        { label: '亲密关系', to: '/category/qin-mi-guan-xi' },
        { label: '性心理健康', to: '/category/xing-xin-li-jian-kang' },
        { label: '伴侣沟通', to: '/category/ban-lv-gou-tong' },
        { label: '性福生活', to: '/category/xing-fu-sheng-huo' },
      ],
    },
    {
      title: '关于我们',
      links: [
        { label: '品牌介绍', to: '/about' },
        { label: '联系我们', to: '/about#contact' },
      ],
    },
    {
      title: '法律信息',
      links: [
        { label: '隐私政策', to: '/about' },
        { label: '使用条款', to: '/about' },
      ],
    },
  ];

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="text-xl font-heading font-bold text-foreground-900">
              性欲社
            </Link>
            <p className="mt-3 text-sm text-foreground-500 leading-relaxed">
              科学、专业、无禁忌的两性健康知识平台。
            </p>
          </div>

          {footerLinks.map((section) => (
            <div key={section.title}>
              <h4 className="text-sm font-semibold text-foreground-800 mb-3">
                {section.title}
              </h4>
              <ul className="flex flex-col gap-2">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-500 hover:text-foreground-800 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 性欲社. 保留所有权利。
          </p>
          <p className="text-xs text-foreground-400">
            本站内容仅供科普参考，不构成医疗建议。如有健康问题请咨询专业医生。
          </p>
        </div>
      </div>
    </footer>
  );
}